import React, { useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";

export const Contact = () => {
  useEffect(() => {
    document.title = `Contact Us | Staidium`;
  }, []);

  return (
    <>
      <Breadcrumb title="Contact Us" />
      <div
        className="static-page"
        style={{ paddingBottom: "90px", paddingTop: "90px" }}
      >
        <Container>
          <Row className="contact-form-wrap section-pb-90">
            <Col lg={12}>
              <Form id="contact-form">
                <div className="contact-page-form">
                  <Row className="contact-input">
                    <Col lg={6} md={6} className="contact-inner black">
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="First Name"
                        id="first-name"
                      />
                    </Col>
                    <Col lg={6} md={6} className="contact-inner black">
                      <Form.Control
                        type="text"
                        name="lastname"
                        placeholder="Last Name"
                        id="last-name"
                      />
                    </Col>
                    <Col lg={6} md={6} className="contact-inner black">
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter Your E-mail"
                        id="email"
                      />
                    </Col>
                    <Col lg={6} md={6} className="contact-inner black">
                      <Form.Control
                        type="text"
                        name="subject"
                        placeholder="Subject"
                        id="subject"
                      />
                    </Col>
                    <Col
                      lg={12}
                      md={12}
                      className="contact-inner black contact-message"
                    >
                      <Form.Control
                        as="textarea"
                        name="message"
                        placeholder="Message"
                        style={{ height: "200px" }}
                      />
                    </Col>
                  </Row>
                  <div className="contact-submit-btn text-center">
                    <Button className="submit-btn" type="submit">
                      Send Message
                    </Button>
                  </div>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
